import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import _JSXStyle from "styled-jsx/style";
import clsx from "clsx";
import { colord } from "colord";
import React, { forwardRef } from "react";
import { getColor } from "../utils";
import classNames from "classnames";
import { Link } from "./Link";
import { Spinner } from "./Spinner";
function getColors(color) {
    var opacity = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
    if (color === "transparent") {
        return {
            bg: "transparent",
            bgDark: "transparent",
            color: "currentColor"
        };
    }
    var bg = getColor(color) || color;
    var bgd = colord(bg).alpha(opacity);
    var text = opacity < 0.8 ? "currentColor" : bgd.isDark() ? "white" : "black";
    // const text = 'currentColor'
    var highlight = bgd.alpha(0.2).toRgbString();
    // console.log({ text, highlight, bg })
    return {
        text: text,
        highlight: highlight,
        bg: bgd.toRgbString()
    };
}
export var Button = /*#__PURE__*/ forwardRef(function(_param, ref) {
    var bg_ = _param.bg, bgDark_ = _param.bgDark, tmp = _param.as, _As = tmp === void 0 ? "button" : tmp, ghost = _param.ghost, _className = _param.className, className = _className === void 0 ? "" : _className, _type = _param.type, type = _type === void 0 ? "button" : _type, _icon = _param.icon, icon = _icon === void 0 ? "" : _icon, children = _param.children, isLoading = _param.isLoading, _disabled = _param.disabled, disabled = _disabled === void 0 ? false : _disabled, href = _param.href, _biggerOnHover = _param.biggerOnHover, biggerOnHover = _biggerOnHover === void 0 ? false : _biggerOnHover, props = _object_without_properties(_param, [
        "bg",
        "bgDark",
        "as",
        "ghost",
        "className",
        "type",
        "icon",
        "children",
        "isLoading",
        "disabled",
        "href",
        "biggerOnHover"
    ]);
    // isLoading = true
    if (!bg_) {
        bg_ = "gray.500";
        bgDark_ = bgDark_ || "gray.300";
    }
    if (!bgDark_ && bg_) {
        bgDark_ = bg_;
    }
    var opacity = ghost ? 0.2 : 1;
    var light = getColors(bg_, opacity);
    var dark = getColors(bgDark_ || bg_, opacity);
    var As = href ? Link : _As;
    var pseudo = ghost ? ":hover" : "";
    return /*#__PURE__*/ _jsxs(As, _object_spread_props(_object_spread({
        ref: ref,
        disabled: disabled || isLoading,
        href: href,
        type: type
    }, props), {
        className: _JSXStyle.dynamic([
            [
                "26bc32a43c811f12",
                [
                    pseudo,
                    light.text,
                    light.bg,
                    pseudo,
                    dark.text,
                    dark.bg,
                    light.highlight,
                    dark.highlight,
                    light.bg,
                    dark.bg
                ]
            ]
        ]) + " " + (props && props.className != null && props.className || clsx("px-[0.8em] !border-0 py-[0.5em] flex appearance-none gap-2 items-center", "justify-center font-medium tracking-wide rounded-md", "cursor-pointer colorAndBg active:opacity-50 transition-colors", biggerOnHover && !disabled && "biggerOnHover", disabled && "opacity-40 pointer-events-none", className) || ""),
        children: [
            _jsx(_JSXStyle, {
                id: "26bc32a43c811f12",
                dynamic: [
                    pseudo,
                    light.text,
                    light.bg,
                    pseudo,
                    dark.text,
                    dark.bg,
                    light.highlight,
                    dark.highlight,
                    light.bg,
                    dark.bg
                ],
                children: ".colorAndBg".concat(pseudo, ".__jsx-style-dynamic-selector{color:").concat(light.text, ";background-color:").concat(light.bg, "}.dark .colorAndBg").concat(pseudo, ".__jsx-style-dynamic-selector{color:").concat(dark.text, ";background-color:").concat(dark.bg, "}.biggerOnHover.__jsx-style-dynamic-selector{-webkit-box-shadow:0 0 0 0 ").concat(light.highlight, ";-moz-box-shadow:0 0 0 0 ").concat(light.highlight, ";box-shadow:0 0 0 0 ").concat(light.highlight, "}.dark .biggerOnHover.__jsx-style-dynamic-selector{-webkit-box-shadow:0 0 0 0 ").concat(dark.highlight, ";-moz-box-shadow:0 0 0 0 ").concat(dark.highlight, ";box-shadow:0 0 0 0 ").concat(dark.highlight, '}.biggerOnHover.__jsx-style-dynamic-selector{-webkit-animation:landingBlocksPulseAnimation 1.75s infinite cubic-bezier(.66,0,0,1);-moz-animation:landingBlocksPulseAnimation 1.75s infinite cubic-bezier(.66,0,0,1);-o-animation:landingBlocksPulseAnimation 1.75s infinite cubic-bezier(.66,0,0,1);animation:landingBlocksPulseAnimation 1.75s infinite cubic-bezier(.66,0,0,1)}@-webkit-keyframes landingBlocksPulseAnimation{to{-webkit-box-shadow:0 0 0 20px rgba(255,255,255,0);box-shadow:0 0 0 20px rgba(255,255,255,0)}}@-moz-keyframes landingBlocksPulseAnimation{to{-moz-box-shadow:0 0 0 20px rgba(255,255,255,0);box-shadow:0 0 0 20px rgba(255,255,255,0)}}@-o-keyframes landingBlocksPulseAnimation{to{box-shadow:0 0 0 20px rgba(255,255,255,0)}}@keyframes landingBlocksPulseAnimation{to{-webkit-box-shadow:0 0 0 20px rgba(255,255,255,0);-moz-box-shadow:0 0 0 20px rgba(255,255,255,0);box-shadow:0 0 0 20px rgba(255,255,255,0)}}.biggerOnHover.__jsx-style-dynamic-selector{-webkit-transition:-webkit-transform.15s;-moz-transition:-moz-transform.15s;-o-transition:-o-transform.15s;transition:-webkit-transform.15s;transition:-moz-transform.15s;transition:-o-transform.15s;transition:transform.15s;cursor:pointer;position:relative;z-index:1}.biggerOnHover.__jsx-style-dynamic-selector::after{content:"";background-color:').concat(light.bg, ";-webkit-transition:-webkit-transform.15s;-moz-transition:-moz-transform.15s;-o-transition:-o-transform.15s;transition:-webkit-transform.15s;transition:-moz-transform.15s;transition:-o-transform.15s;transition:transform.15s;-webkit-border-radius:7px;-moz-border-radius:7px;border-radius:7px;position:absolute;inset:0;z-index:-1}.dark .biggerOnHover.__jsx-style-dynamic-selector::after{background-color:").concat(dark.bg, "}.biggerOnHover.__jsx-style-dynamic-selector:hover::after,.biggerOnHover.__jsx-style-dynamic-selector:active::after{-webkit-transform:scaleX(1.03)scaleY(1.14);-moz-transform:scaleX(1.03)scaleY(1.14);-ms-transform:scaleX(1.03)scaleY(1.14);-o-transform:scaleX(1.03)scaleY(1.14);transform:scaleX(1.03)scaleY(1.14)}")
            }),
            icon && /*#__PURE__*/ _jsx("div", {
                className: _JSXStyle.dynamic([
                    [
                        "26bc32a43c811f12",
                        [
                            pseudo,
                            light.text,
                            light.bg,
                            pseudo,
                            dark.text,
                            dark.bg,
                            light.highlight,
                            dark.highlight,
                            light.bg,
                            dark.bg
                        ]
                    ]
                ]) + " " + "",
                children: icon
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: _JSXStyle.dynamic([
                    [
                        "26bc32a43c811f12",
                        [
                            pseudo,
                            light.text,
                            light.bg,
                            pseudo,
                            dark.text,
                            dark.bg,
                            light.highlight,
                            dark.highlight,
                            light.bg,
                            dark.bg
                        ]
                    ]
                ]) + " " + "relative",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: _JSXStyle.dynamic([
                            [
                                "26bc32a43c811f12",
                                [
                                    pseudo,
                                    light.text,
                                    light.bg,
                                    pseudo,
                                    dark.text,
                                    dark.bg,
                                    light.highlight,
                                    dark.highlight,
                                    light.bg,
                                    dark.bg
                                ]
                            ]
                        ]) + " " + (classNames("absolute inset-0 flex item-center justify-center colorAndBg", !isLoading && "hidden") || ""),
                        children: /*#__PURE__*/ _jsx(Spinner, {})
                    }),
                    children
                ]
            })
        ]
    }));
});
Button.displayName = "Button";
